/**
 * What a coaching result item was judged on: its overall (only when measured —
 * never a 0 for "not measured"), the rubric it was assessed against and the
 * evidence classes. ONE rendering for every list that shows a result item:
 * the owner's portfolio list, share links and the public /u/:slug list.
 */
export interface ResultProvenanceView {
  rubric: { id: string; version: string; title: string | null } | null;
  evidenceClasses: string[];
  overall?: number | null;
}

export function ResultProvenance({ result, testId = 'result-provenance' }: { result: ResultProvenanceView; testId?: string }) {
  const parts: string[] = [];
  if (typeof result.overall === 'number') parts.push(`Overall ${Math.round(result.overall)}`);
  if (result.rubric) parts.push(`Assessed against ${result.rubric.title ?? result.rubric.id} (v${result.rubric.version})`);
  if (result.evidenceClasses.length > 0) {
    parts.push(`Evidence: ${result.evidenceClasses.map((c) => c.toLowerCase().replace(/_/g, ' ')).join(', ')}`);
  }
  if (parts.length === 0) return null;
  return (
    <p className="text-xs text-gray-500 mt-1" data-testid={testId}>
      {parts.join(' · ')}
    </p>
  );
}
